import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";

const API = "/ics_get_header_file_ics_v1";

export const REQUEST_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
});

const initialState = {
  files: {
    data: [],
    hasMore: true,
    status: REQUEST_STATUS.IDLE,
    error: null,
    search: "",
  },
  selectedFileIds: [],
  fileNameCache: {}
};

export const getSelectedAuditedFilesMenuData = createAsyncThunk(
  "workflow/getSelectedAuditedFilesMenuData",
  async ({ pageNumber = 1, search = "" } = {}, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API, {
        params: {
          page_number: pageNumber,
          search: search || undefined, // omit the param entirely when empty
        },
      });

      return fulfillWithValue({
        results: response.data.data.headers,
        pageNumber,
        search,
      });
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong",
      );
    }
  },
);

const workflowSlice = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    resetSelectedAuditedFiles(state) {
      state.files = {
        data: [],
        hasMore: true,
        status: REQUEST_STATUS.IDLE,
        error: null,
        search: "",
      };
    },
     setSelectedFileIds: (state, action) => {
      state.selectedFileIds = action.payload;
    },
       // action.payload: array of { id, fileName }
    cacheFileNames: (state, action) => {
       action.payload.forEach(({ id, fileName }) => {
         if (id != null && fileName) {
           state.fileNameCache[String(id)] = fileName;
         }
       });
      },
    
    removeSelectedFileId: (state, action) => {
      state.selectedFileIds = state.selectedFileIds.filter(
        (id) => id !== action.payload
      );
    },
    
    clearSelectedFileIds: (state) => {
      state.selectedFileIds = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSelectedAuditedFilesMenuData.pending, (state) => {
        state.files.status = REQUEST_STATUS.LOADING;
      })
      .addCase(getSelectedAuditedFilesMenuData.fulfilled, (state, action) => {
        state.files.status = REQUEST_STATUS.SUCCESS;
        const { results, pageNumber, search } = action.payload;

        // Page 1 always REPLACES the list — this covers both a fresh load
        // and a new search term (which always starts back at page 1).
        if (pageNumber === 1) {
          state.files.data = results;
        } else {
          state.files.data = [...state.files.data, ...results];
        }

        state.files.hasMore = results.length > 0;
        state.files.search = search;
      })
      .addCase(getSelectedAuditedFilesMenuData.rejected, (state, action) => {
        state.files.status = REQUEST_STATUS.FAILURE;
        state.files.error = action.payload;
        state.files.hasMore = false;
      });
    },
});

export const { resetSelectedAuditedFiles, setSelectedFileIds, 
  removeSelectedFileId,    
  clearSelectedFileIds,cacheFileNames } = workflowSlice.actions;
export default workflowSlice.reducer;